import { BooleanStatus } from '../helpers/BooleanStatus';
import { Interconnect, Point } from '@/types';
import { ArrowRightIcon } from '@iconicicons/react';
import React from 'react';

export type InterconnectListItemProps = {
  interconnect: Interconnect;
  startPoint: Point;
  endPoint: Point;
  disabled?: boolean;
  displacement?: boolean;
  onClick?: (interconnect: Interconnect) => void;
};

export const InterconnectListItem: React.FC<InterconnectListItemProps> = ({
  interconnect,
  startPoint,
  endPoint,
  displacement = false,
  disabled = false,
  onClick,
}) => {
  const interconnectName =
    interconnect.alias ?? `From ${startPoint.name} to ${endPoint.name}`;

  return (
    <div
      key={interconnect.id}
      role="button"
      style={{
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
      onClick={() => onClick?.(interconnect)}
    >
      <div>
        <b>#{interconnect.id}</b> {displacement && 'Displace '}
        {interconnectName}
        {interconnect.alias && (
          <p
            className="text-muted py-0 my-0 d-flex align-items-center"
            style={{ fontSize: '14px' }}
          >
            {startPoint.name} <ArrowRightIcon className="mx-2" />
            {endPoint.name}
          </p>
        )}
      </div>
      <div className="d-flex gap-3">
        <span>Receipt Zone: {startPoint.receipt_zone_name}</span>
        <span>Delivery Zone: {endPoint.delivery_zone_name}</span>
      </div>
      <div className="d-flex gap-3 mt-3">
        <span>
          {startPoint.tsp_name}{' '}
          <ArrowRightIcon
            color={displacement ? 'var(--bs-danger)' : 'var(--bs-success)'}
          />{' '}
          {endPoint.tsp_name}
        </span>
      </div>
      <div className="text-end d-flex justify-content-end gap-3 mt-2">
        <BooleanStatus
          value={interconnect.enabled && !disabled}
          trueText="Enabled"
          falseText={disabled ? 'Not Allowed' : 'Disabled'}
        />
      </div>
      <hr />
    </div>
  );
};
